module.exports = __webpack_public_path__ + "static/media/eg.4137f108.svg";